import { debounce } from 'lodash'
import { useLayoutEffect, useState } from 'react'

export const BASE_WIDTH = 1280
export const BASE_HEIGHT = 720
export const RESIZE_DEBOUNCE_TIME = 100

export function useScreenScale() {
  const [scale, setScale] = useState(1)
  const [dynamicHeight, setDynamicHeight] = useState(BASE_HEIGHT)

  useLayoutEffect(() => {
    const handleResize = () => {
      const newScale = window.innerWidth / BASE_WIDTH

      setScale(newScale)
      setDynamicHeight(window.innerHeight / newScale)
    }

    handleResize()

    const debouncedResize = debounce(handleResize, RESIZE_DEBOUNCE_TIME)
    window.addEventListener('resize', debouncedResize)

    return () => {
      window.removeEventListener('resize', debouncedResize)
      debouncedResize.cancel()
    }
  }, [])

  return { scale, baseWidth: BASE_WIDTH, dynamicHeight }
}
